import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../app.constants';

import { UserRouteAccessService } from '../shared';
import { HomeComponent } from './home.component';

export const HOME_ROUTE: Route = {
  path: 'accueil',
  component: HomeComponent,
  data: {
    needAuthentication: true,
    pageTitle: `Accueil${PAGE_TITLE_SUFFIX}`
  },
  canActivate: [UserRouteAccessService]
};

export const DEFAULT_ROUTE: Route = {
    path: '',
    redirectTo: 'authentication',
    pathMatch: 'full'
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.route.ts